// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/home.scss
// module id = 22
// module chunks = 0